/* import __COLOCATED_TEMPLATE__ from './stale.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import ProjectStaleKeepActiveModal from 'sh-www/components/modals/project/stale-keep-active';
import { tracked } from '@glimmer/tracking';
import { closeModal, showNextModal } from 'sh-www/utils/modal-controls';
import { dropTask } from 'ember-concurrency';
import { handleErrorResponse } from 'sh-www/utils/handles-errors';

class ProjectStaleModalComponent extends Component {
  @service('commands.application-commands') applicationCommandService;
  @service('state-managers.application') applicationStateManager;
  @service moment;
  @service router;

  @tracked errors = {};

  get timeTillCancelString() {
    const { remediationBeginsAt } = this.args.model.application;
    const endOfRemediation = this.moment.moment(remediationBeginsAt).add(7, 'day');
    return this.moment.moment().diff(endOfRemediation, 'days') >= 0
      ? 'less than a day'
      : endOfRemediation.from(this.moment.moment(), true);
  }

  @action
  onKeepActiveClicked() {
    showNextModal(this, ProjectStaleKeepActiveModal, {
      application: this.args.model.application,
      reloadApplicationCallback: this.args.model.reloadApplicationCallback,
    })
  }

  @dropTask
  *onCancelProjectClicked() {
    this.errors = {};

    try {
      yield this.applicationCommandService.cancelApplication(
        this.args.model.application,
        null,
        '',
        '',
        false,
        true
      );
      this.args.model.reloadApplicationCallback();
      this.applicationStateManager.addToast('Project canceled');
      closeModal(this);
    } catch (error) {
      handleErrorResponse(this, error, ['generic-exception']);
    }
  }

  @action
  onSkipClicked() {
    closeModal(this);
  }
}

export default ProjectStaleModalComponent;
